import React, { useEffect, useState, useContext } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Select, MenuItem, FormControl, Container, Stack, IconButton,} from '@mui/material';
import { AccountCircleOutlined, ExpandMore, ShoppingBasketOutlined } from '@mui/icons-material';
import logo from '../../assets/logo-no-bg.png'
import { Context } from '../../App';
import { Link } from 'react-router-dom';
import AccountMenu from '../ui/AccountMenu';
import fond1 from '../../assets/fond1.png';

const Header = () => {
  const {region, setRegion, regions, isConnected} = useContext(Context);

  const [navigationItems, setNavItem] = useState(region===null? [] : [
    { label: 'Accueil', href: '/', active: true },
    { label: 'Billeterie', href: '/billeterie' },
    { label: 'À propos', href: '/about' },
  ]);

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  useEffect(() => {
    // Update the active state based on the current URL
    const currentPath = window.location.pathname;
    setNavItem((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        active: item.href === currentPath,
      }))
    );
  }, []);

  useEffect(() => {
    const currentPath = window.location.pathname;
    setNavItem(region===null? [] : [
      { label: 'Accueil', href: '/', active: true },
      { label: 'Billeterie', href: '/billeterie' },
      { label: 'À propos', href: '/about' },])
  }, [region, setRegion]);

  return (
    <>
      <AppBar position="static" sx={{ backgroundImage: `url(${fond1})`, backgroundSize: 'cover', flexShrink:0, width: '100%', minWidth:'300px' }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            {/* Logo */}
            <Box sx={{ display: 'flex', flexGrow:1, alignItems: 'end', mr: 4, cursor: 'pointer', '&:hover': {opacity: 0.8} }} onClick={() => window.location.href = '/'}>
                <img src={logo} style={{ width: '70px'}}/>
            </Box>

            {/* Navigation Menu */}
            {/* <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex', justifyContent:'space-around' }, marginInline:5, gap: 5 }}>
              {navigationItems.map((item) => (
                <Button
                  key={item.label}
                  color="inherit"
                  href={item.href}
                  sx={{
                    fontSize: '16px',
                    fontWeight: item.active ? 'bold' : 'normal',
                    color: 'secondary.main',
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box> */}

            <Stack direction="row" spacing={4} alignItems='center' sx={{ flexGrow: 0, display: { md: 'flex' } }}>
              <Link to='/contact' style={{ textDecoration: 'none', color:'white', fontFamily:'Merriweather Sans, sans-serif' }}>Contact</Link>
              <Stack direction='row' spacing={1} alignItems='center'>
                <IconButton href='/panier' size='large'><ShoppingBasketOutlined fontSize='large' style={{color:'white'}}/></IconButton>
                {isConnected ? <AccountMenu />
                :
                <IconButton href={'/connexion'} size='large'><AccountCircleOutlined fontSize='large' style={{color:'white'}}/></IconButton>}
              </Stack>
            </Stack>
            {/* Connexion Button */}
            {/* {isConnected? 
            <IconButton href='/compte' size='large'><AccountCircleOutlined/></IconButton>
            :<Button
              variant="outlined"
              sx={{
                width: 'fit-content',
                color: 'white',
                borderColor: 'white',
                px: 3,
                '&:hover': {
                  backgroundColor: 'white',
                  color: 'primary.main',
                },
              }}
            >
              Connexion
            </Button>} */}
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default Header;